import server from "api/server";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import fileUpload from "assets/images/fileUpload.svg";
import fileCompleted from "assets/images/fileCompleted.svg";
import removeImg from "assets/svgs/close.svg";

const PdfUpdate = ({ index, item, sliders, setSliders, style = {} }) => {
  const [selectedPdfFile, setSelectedPdfFile] = useState({
    preview: null,
    path: "",
  });
  const [uploadProgress, setUploadProgress] = useState(0); // Track upload progress
  const [isUploading, setIsUploading] = useState(false); // Track upload state

  const imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setIsUploading(true); // Set uploading to true
      const formData = new FormData();
      formData.append("file", e.target.files[0]);

      try {
        const { data } = await server().post("/upload", formData, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted); // Update progress
          },
        });

        setSelectedPdfFile({
          preview: e.target.files[0],
          path: data?.data?.file.fullpath,
        });

        const newSections = sliders.map((section, childIndex) => {
          if (index !== childIndex) return section;
          return {
            ...section,
            pdfFile: `${data?.data?.file.fullpath}`,
          };
        });

        setSliders(() => newSections);
      } catch (error) {
        console.error("Upload error", error);
      } finally {
        setIsUploading(false); // Reset uploading state
        setUploadProgress(0); // Reset progress
      }

      e.target.value = null;
    }
  };

  const removeSelectedPdfFile = () => {
    // e.preventDefault();

    setSelectedPdfFile({
      preview: null,
      path: "",
    });
    setSelectedPdfFile("");
    const newSections = sliders.map((section, childIndex) => {
      if (index !== childIndex) return section;
      return {
        ...section,
        // pdfFile: "",
        pdfFile: ``,
      };
    });

    setSliders(() => newSections);
  };

  return (
    <div className="form-group required">
      <h5>
        <FormattedMessage id={"pdfFile"} />
      </h5>

      <div className="image-uploader image-contain m-auto" style={style}>
        <div className="img-pat">
          {isUploading ? (
            <div className="progress-indicator">
              <span>{uploadProgress}%</span>
            </div>
          ) : (
            <img
              src={fileUpload}
              width={50}
              height={50}
              alt=""
              className="filePdfIcon"
            />
          )}
        </div>
        <label>
          {(selectedPdfFile.preview || item?.pdfFile) && (
            <div className="filePdfIconDiv">
              <img
                src={
                  !selectedPdfFile && selectedPdfFile.preview
                    ? URL.createObjectURL(selectedPdfFile.preview)
                    : fileCompleted
                }
                width={50}
                height={50}
                alt=""
                className="filePdfIcon"
              />
              <button
                type="button"
                className="removeImg"
                onClick={removeSelectedPdfFile}
              >
                <img src={removeImg} alt="" />
              </button>
            </div>
          )}
          <input accept="pdf/*" type="file" onChange={imageChange} />
        </label>
      </div>
    </div>
  );
};

export default PdfUpdate;
